import { render, staticRenderFns } from "./ServiceInvoices.vue?vue&type=template&id=f5a6fa7a&"
import script from "./ServiceInvoices.vue?vue&type=script&lang=js&"
export * from "./ServiceInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports